package com.karawek.core.network

import kotlin.coroutines.cancellation.CancellationException

/**
 * Raised by [AuthClientPlugin] when a request requires authentication but the
 * platform SDK has no live session (expired or revoked).
 *
 * It extends [CancellationException] on purpose: an uncaught occurrence quietly
 * cancels the calling coroutine — e.g. a Compose `produceState`/`LaunchedEffect`
 * loading data — instead of crashing the app. Navigation to login is driven
 * separately by the app's auth gate, which reacts to the session being cleared
 * (the plugin calls `invalidateLocal()` before throwing).
 */
class SessionExpiredException(
    message: String = "Session expired",
) : CancellationException(message)
